import React, {useRef, useEffect} from "react";
import useCamera from "./hook";
import LoaderLulo from "../../../../components/loaderLulo";
import Loader from "../../../../components/loader";
import "./index.css"


export default function CardCaptureV2() {
    const lottieRef = useRef();
    const guideAdo = useRef()
    const textPreview = useRef()
    const closeIcon = useRef()
    const takePhoto = useRef()
    const videoRef = useRef()
    const canvasRef = useRef()
    const containerRef = useRef()

    const {
        canvasCroppedImageRef,
        indicatorRotate,
        debug,
        step,
        stepHistory,
        ocr,
        isCard,
        isImageValidate,
        projectName,
        typeCapture,
        goBack,
        isMovil,
        takeManualPhoto,
        guideMessage
    } = useCamera({containerRef, guideAdo, textPreview, closeIcon, takePhoto, videoRef, canvasRef})

    useEffect(() => {
        const animation = lottieRef.current;
        if (animation) {
            animation.setSpeed(2.5);
            animation.play();
        }
    }, [])
    // 300 y 500

    // if (isMovil()) {
        return (
            <div ref={containerRef} className="v2 card-capture-container-ado hide-elements">
                <div className="guide-elements-container">
                    <div className="close-btn-wrapper">
                        <div ref={closeIcon} className="close-btn" onClick={goBack} />
                    </div>

                    <div className="video-guide-container">
                        <div ref={guideAdo} className="video-container" >
                            <div className="dashed-mark"></div>
                            <video style={{transform: isMovil() ? 'scaleX(1)' : 'scaleX(-1)'}} ref={videoRef} className={`container__camera-movil video-movil`} controls={false} autoPlay playsInline />
                        </div>
                        <div ref={textPreview} className="text-guide">
                            Ubíca la parte de adelante de tu documento
                        </div>
                        <span className="text-guide-light">{guideMessage}</span>
                    </div>

                    <div ref={takePhoto} onClick={takeManualPhoto} className="take-photo-wrapper hide" >
                        <div className="take-photo" />
                    </div>
                </div>
                <canvas
                    id="canvas-view"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'none',
                    }}
                    ref={canvasRef}
                />
                <img alt="imgResult" id="imgResult" style={{display: 'none', width: '100%'}} />
                <div id="message-alert-ado" className="message-alert-ado">
                    <h2>Error al validar el documento</h2>
                    <p>Verifique que el documento se vea correctamente</p>
                </div>
            </div>
        )
    // }

    // return (
    //     <div className="container__camera desktop">
    //         {debug === 'true' && (
    //             <>
    //                 <div style={{position: 'absolute', zIndex: 200, width: '100%', top: 0, display: 'flex', justifyContent: 'space-around'}}>
    //                     <div>
    //                         <h5 style={{color: 'white'}}>Image</h5>
    //                         <h5 style={{color: 'white'}}>{isImageValidate ? 'Si' : 'No'}</h5>
    //                     </div>
    //                     <div>
    //                         <h5 style={{color: 'white'}}>OCR</h5>
    //                         <h5 style={{color: 'white'}}>{ocr}</h5>
    //                     </div>
    //                     <div>
    //                         <h5 style={{color: 'white'}}>isCard</h5>
    //                         <h5 style={{color: 'white'}}>{isCard}</h5>
    //                     </div>
    //                 </div>
    //             </>
    //         )}


    //         <div id="container-ado-camera">
    //             <video id="video-camera" className={`container__camera-camera ${!isMovil() ? 'video-mirror' : ''}`} ref={videoRef} autoPlay playsInline/>
    //         </div>

    //         <div onClick={goBack} className="imgback" id="img-back-ado">
    //             X
    //         </div>

    //         <input id="input-ado-copy" style={{display: 'none',  width: '90%', padding: 20}} />
    //         <canvas id="canvas-view" ref={canvasRef} style={{display: 'none'}}  />

    //         <img alt="imgResult" id="imgResult" style={{display: 'none', width: '100%'}} />
    //         {debug === 'true' && (
    //             <>
    //                 <div style={{position: 'absolute', width: '100%', bottom: '8rem', display: 'flex', justifyContent: 'space-around'}}>
    //                     <div>
    //                         <div style={{height: 200, overflowY: 'scroll', display: 'none'}}>
    //                             <h5 style={{color: 'white'}}>Step history</h5>
    //                             {stepHistory.map(step => (
    //                                 <h5 style={{color: 'white'}}>{step}</h5>
    //                             ))}
    //                         </div>

    //                         <div style={{marginTop: 10}}>
    //                             <h5 style={{color: 'white'}}>Current Step</h5>
    //                             <h5 style={{color: 'white'}}>{step}</h5>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </>
    //         )}
    //     </div>
    // )
}
